import React, { useContext } from 'react'
import RechartPie from './RechartPIE'
import MarginAnalysisContext from 'marginanalysis/MarginAnalysisContext'
import R from 'ramda'
import numeral from 'numeral'
import { getFinalData } from 'marginanalysis/utils'
export default props => {
  const {
    whatIf = false,
    actualHeight = 170,
    actualWidth = 300,
    isEventPlanner = false,
  } = props

  const height = actualHeight
  const width = actualWidth

  const marginContext = useContext(MarginAnalysisContext)

  const { events = [] } = getFinalData(marginContext, whatIf, isEventPlanner)

  // 12/15/2023 , as per new rule  , informed by Wing sir
  // for sum : need to include the all data
  // but if final total is < 0 , then need to show 0
  // Total Forced = Greatest( sum(Forced lost margin), 0)
  // Total Maint = Greatest( sum(Maint lost margin), 0)
  // Total Plan = Greatest( sum(plan lost margin), 0)

  const getLostMarginValue = val => {
    if (val && !isNaN(val)) {
      try {
        const numVal = parseFloat(val)
        // return numVal && numVal > 0 ? numVal : 0
        return numVal
      } catch (error) {
        return 0
      }
    } else return 0
  }

  let calcData = R.compose(
    R.reduce((a, b) => ({ ...a, ...b }), { F: 0, M: 0, P: 0 }),
    R.map(([k, v]) => ({
      [k]: R.reduce(
        (a, b) => a + b,
        0,
        v.map(r => getLostMarginValue(r.lostOppMargin || 0) || 0)
      ),
    })),
    R.toPairs,
    R.groupBy(e => e.type),
    R.filter(e => e.type)
  )(events)

  // update calData as per new rule
  const valUpdate = total => (total >= 0 ? parseInt(total) : 0)
  calcData = {
    F: valUpdate(calcData.F),
    M: valUpdate(calcData.M),
    P: valUpdate(calcData.P),
  }

  const getLabel = rec => {
    return rec.name + ' $(' + numeral(rec.value).format('000,000') + ')'
  }

  const data = [
    {
      name: 'Forced',
      value: parseInt(calcData.F || 0),
      index: 0,
      getLabel,
      color: '#f4433694',
      // color: 'rgba(68, 99, 147)',
    },
    {
      name: 'Maint',
      value: parseInt(calcData.M || 0),
      index: 1,
      getLabel,
      color: '#3f51b5b5',
      // color: 'rgb(68, 99, 147)',
    },
    {
      name: 'Planned',
      value: parseInt(calcData.P || 0),
      index: 2,
      getLabel,
      color: '#08f508a8',
    },
  ]

  return (
    <RechartPie
      data={R.sortBy(d => d.value, data)}
      height={height}
      width={width}
      title="Lost Margin"
      legend
      applyLableCalc
    />
  )
}
